// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__VL0aP","section":"index_section__Afu0q","title":"index_title__NgBlX","hint":"index_hint__caTqr","desc":"index_desc__LCLOS","value":"index_value__6i5aO"};